class CustomBlog extends HTMLElement {

    constructor() {
        super();
        // Replace these constants with your Shopify store details
        this.STOREFRONT_ACCESS_TOKEN = "79184a0fd256fe46258feacedc34bc09";
        this.SHOP_DOMAIN = "afd2fb.myshopify.com";
        this.BLOG_HANDLE = "news"; // e.g., "news"

        // GraphQL endpoint
        this.API_URL = `https://${this.SHOP_DOMAIN}/api/2025-01/graphql.json`;

        this.filterColumn = document.getElementById('blog-filter-column');
        this.articleItemTemplate = document.getElementById('article-item').innerHTML;
        this.paginationTemplate = document.getElementById('pagination-list').innerHTML;
        this.articleListContainer = this.querySelector('.blog__article-list');
        this.paginationContainer = this.querySelector('.blog__pagination .pagination__list');

        this.dropdownTrigger = 'button.dropdown-button';
        this.newsFilter = '.tag-news-type[type="checkbox"]';
        this.yearFilter = '.year-filter[type="checkbox"]';
        this.brandFilter = '.brand-filter[type="checkbox"]';
        this.sortSelector = document.getElementById('sort-date-reversed');
        this.searchField = document.getElementById('search-articles');
        this.searchBtn = document.getElementById('search-btn');
        this.filterToggleBtn = document.getElementById('blog-filter-toggle');
        this.paginationObj = {};
        this.paginationDirection = null;
        this.resultsPerPage = 24;
    }

    connectedCallback() {
        this.addListeners();
    }

    addListeners() {
        const self = this;

        [...this.querySelectorAll(this.newsFilter)].forEach((el) => {
            el.addEventListener("click", function(event) {
                self.closeAllDropdowns();
                self.handleArticles();
            });
        });

        [...this.querySelectorAll(this.brandFilter)].forEach((el) => {
            el.addEventListener("click", function(event) {
                self.closeAllDropdowns();
                self.handleArticles();
            });
        });

        [...this.querySelectorAll(this.yearFilter)].forEach((el) => {
            el.addEventListener("click", function(event) {
                self.closeAllDropdowns();
                self.handleArticles();
            });
        });

        [...this.querySelectorAll(this.dropdownTrigger)].forEach((el) => {
            el.addEventListener("click", function(event) {
                self.toggleDropdown(el);
            });
        });

        this.sortSelector.addEventListener("change", function(event) {
            self.handleArticles();
        });

        this.searchBtn.addEventListener("click", function(event) {
            self.closeAllDropdowns();
            self.handleArticles(true);
        });

        this.searchField.addEventListener("keyup", function (event) {
            if (event.keyCode === 13) {
                self.closeAllDropdowns();
                self.handleArticles(true);
            }
        });

        this.filterToggleBtn.addEventListener("click", function(event) {
           if(self.filterColumn.classList.contains('open'))
            {   
                self.filterColumn.classList.remove('open');
                this.classList.remove('open');
            }else{
                self.filterColumn.classList.add('open');
                this.classList.add('open');
            }
        });

    }

    // Function to fetch blog articles
    async fetchBlogArticles() {

        const yearQuery = this.buildTagQuery(this.yearFilter);
        const brandQuery = this.buildTagQuery(this.brandFilter);
        const typeQuery = this.buildTagQuery(this.newsFilter);
        const sortKey = 'PUBLISHED_AT';
        const isReversed = this.sortSelector.value; 

        let queries = [];
        let paginateCursor = '';

        if (yearQuery) queries.push(yearQuery);
        if (brandQuery) queries.push(brandQuery);
        if (typeQuery) queries.push(typeQuery);

        const filterQuery = queries.length > 0 ? `query: "${queries.join(' AND ')}",` : '';


        if(this.paginationDirection == 'next'){
            paginateCursor = `, first: ${this.resultsPerPage}, after:"${this.paginationObj?.endCursor}"`;
        }else if(this.paginationDirection == 'previous'){
            paginateCursor = `, last: ${this.resultsPerPage}, before:"${this.paginationObj?.startCursor}"`;
        }else{
             paginateCursor = `, first: ${this.resultsPerPage}`;
        }

        const query = `
        {
          blog(handle: \"${this.BLOG_HANDLE}\") {
            articles(`+filterQuery+`sortKey: ${sortKey}, reverse:${isReversed} ${paginateCursor}) {
              edges {
                node {
                    title
                    publishedAt
                    tags
                    excerpt
                    content(truncateAt: 50)
                    handle
                    image{
                        altText
                        url
                        thumbnail: url(transform: { maxWidth: 320, crop: CENTER })
                        large: url(transform: { maxWidth: 670, crop: CENTER })
                    }
                    linkOverride: metafield(namespace: "custom", key: "page_link_override") {
                        value
                    }
                }
              }
             pageInfo {
                  hasNextPage
                  endCursor
                  hasPreviousPage
                  startCursor
                }
            }
          }
        }`;
console.log(query);
        const response = await fetch(this.API_URL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Shopify-Storefront-Access-Token": this.STOREFRONT_ACCESS_TOKEN,
            },
            body: JSON.stringify({ query }),
        });

        const result = await response.json();

        if (result.errors) {
            console.error("Errors: ", result.errors);
            return [];
        }

        this.paginationObj = result.data.blog.articles.pageInfo;
        console.log(this.paginationObj);
        return result.data.blog.articles.edges.map(edge => edge.node);
    }

    async fetchSearchArticles() {

        const searchValue = this.searchField.value; 

        const filterQuery = `query: "${searchValue}",`;

        const query = `
        {
            search(`+filterQuery+`first: 100, types: ARTICLE) {
              edges {
                node {
                ... on Article {
                        title
                        publishedAt
                        tags
                        excerpt
                        content(truncateAt: 50)
                        handle
                        image{
                            altText
                            url
                            thumbnail: url(transform: { maxWidth: 320, crop: CENTER })
                            large: url(transform: { maxWidth: 670, crop: CENTER })
                        }
                        linkOverride: metafield(namespace: "custom", key: "page_link_override") {
                            value
                        }
                    }
                }
              }
              pageInfo {
                  hasNextPage
                  endCursor
                  hasPreviousPage
                  startCursor
                }
            }
        }`;
console.log(query);
        const response = await fetch(this.API_URL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Shopify-Storefront-Access-Token": this.STOREFRONT_ACCESS_TOKEN,
            },
            body: JSON.stringify({ query }),
        });

        const result = await response.json();

        if (result.errors) {
            console.error("Errors: ", result.errors);
            return [];
        }
        this.paginationObj = result.data.search.pageInfo;
        return result.data.search.edges.map(edge => edge.node);
    }

    yearFilter(){
        const articles = data.blog.articles.edges
          .map(edge => edge.node)
          .filter(article => {
            const publishedDate = new Date(article.publishedAt);
            return publishedDate >= new Date("2021-01-01T00:00:00Z") &&
                   publishedDate <= new Date("2021-12-31T23:59:59Z");
          });
    }

    buildYearQuery() {
        // Select all checked checkboxes
        const checkedYears = document.querySelectorAll(this.yearFilter+':checked');
        
        if (checkedYears.length === 0) return ''; // Return empty string if no years are selected

        // Extract years from the checkboxes' data-querystring attribute
        const years = Array.from(checkedYears).map(checkbox => checkbox.value);

        // Build OR conditions for each selected year
        const yearConditions = years.map(year => `(created_at:>='${year}-01-01T00:00:00Z' AND created_at:<='${year}-12-31T23:59:59Z')`);
        
        // Join them with OR and wrap in parentheses
        return yearConditions.length > 0 ? `${yearConditions.join(' OR ')}` : '';
    }

    buildTagQuery(tagClass){
        // Select all checked checkboxes
        const checkedBoxes = document.querySelectorAll(tagClass+':checked');
        const parentEl = document.querySelector(tagClass).closest('.dropdown');
        const activeDisplayEl = parentEl.querySelector('.active-filters');

        // Extract values and format as "tag:'VALUE'"
        const queryParts = Array.from(checkedBoxes)
                                .map(checkbox => `tag:'${checkbox.value}'`);

        const activeTags = Array.from(checkedBoxes).map(checkbox => checkbox.value);

        if(activeTags.length > 0){
            activeDisplayEl.innerHTML = activeTags.join(',');
        }else{
            activeDisplayEl.innerHTML = 'All'; 
        }

        // Join them with " OR " and wrap in parentheses                    
        const query = queryParts.length > 0 ? `(${queryParts.join(' OR ')})` : '';

        return query;
    }

    toggleDropdown(element){
        if(element.nextElementSibling.style.display == 'block')
        {   
            element.classList.remove('open');
            element.nextElementSibling.style.display = 'none';
        }else{
            element.classList.add('open');
            element.nextElementSibling.style.display = 'block';
        }
    }

    closeAllDropdowns(){
        this.filterColumn.classList.remove('open');
        this.filterToggleBtn.classList.remove('open');

        [...this.querySelectorAll(this.dropdownTrigger)].forEach((el) => {
            el.classList.remove('open');
            el.nextElementSibling.style.display = 'none';
        });
    }

    renderArticles(processedArticles) {
        let renderedHTML = '';

        if(processedArticles.length > 0){
            processedArticles.map((item) => {
                renderedHTML += ejs.render(this.articleItemTemplate, item);
            })
            
            this.articleListContainer.innerHTML = renderedHTML;
            this.paginationContainer.innerHTML = ejs.render(this.paginationTemplate,  this.paginationObj);
        }else{
            this.articleListContainer.innerHTML = `<li class="no-results">No results for applied filters.</li>`;
            this.paginationContainer.innerHTML = "";
        }
        
    }

    // Main function to handle fetching, sorting, and filtering
    async handleArticles(isSearch = false) {
        try {
            let articles = {};

            if(isSearch){
                articles = await this.fetchSearchArticles();
            }else{
                articles = await this.fetchBlogArticles();
            }
            this.renderArticles(articles);
        } catch (error) {
            console.error("Failed to fetch articles: ", error);
        }
    }

    paginate(direction){

        this.paginationDirection = direction;
        this.handleArticles();
        //clear out variable
        this.paginationDirection = null;
    }

}
customElements.define('custom-blog', CustomBlog);
